"use strict";

var _getEnvironment = require("./getEnvironment");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isWebView = isWebView;

function isWebView() {
  switch ((0, _getEnvironment.getEnvironment)()) {
    case "Android":
    case "Cupertino":
      return !0;

    default:
      return !1;
  }
}